import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { ButtonBase, Grid, Stack } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Common/Breadcrumb.js";
import Header from "../../../components/VerticalLayout/Header";
import "../setting.css";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import LoadingDialog from "../../../components/Common/LoadingDialog.js";
import Notification from "../../../components/Common/Notification.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomTextField from "../../../components/Form/CustomTextField.js";
import { deleteReuseable, getReuseableListing, resetReuseableSettingActionState, resetReuseableSettingState, updateReuseable } from "../../../store/actions.js";
import CustomButton from "../../../components/Form/CustomButton.js";
import FormEditors from "../../Forms/FormEditors.js";


const GeneralSetting = ({ userPermission, settingListing, updateSetting }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setIsLoading] = useState(false);
    const [name, setSearch] = useState("");
    const [currentSection, setCurrentSection] = useState("Business Setup");
    const [merchantTypes, setMerchantTypes] = useState(['']);
    const [outletTypes, setOutletTypes] = useState(['']);
    const [serviceTypes, setServiceTypes] = useState(['']);
    const [taskTypes, setTaskTypes] = useState(['']);
    const [topicOfIssues, setTopicOfIssues] = useState(['']);
    const [returnReasons, setReturnReasons] = useState(['']);
    const [replacementReasons, setReplacementReasons] = useState(['']);
    const [adjustmentReasons, setAdjustmentReasons] = useState(['']);
    const [forfeitPeriod, setForfeitPeriod] = useState();
    const [quotationValidity, setQuotationValidity] = useState();
    const [invoicePaymentPeriod, setInvoicePaymentPeriod] = useState();
    const [paymentCollectionPeriod, setPaymentCollectionPeriod] = useState();
    const [overduePaymentNotification, setOverduePaymentNotification] = useState();
    const [overdueDeliveryNotification, setOverdueDeliveryNotification] = useState();
    const [agreementContent, setAgreementContent] = useState();
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);

    const [width, setWidth] = useState(window.innerWidth);

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        dispatch(resetReuseableSettingState());

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
            dispatch(resetReuseableSettingState());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
        }
    }, [userPermission])

    useEffect(() => {
        initData();
    }, [currentSection])

    useEffect(() => {
        if (settingListing?.data) {
            if (currentSection === 'Business Setup') {
                const businessSetup = settingListing?.data;
                setMerchantTypes(businessSetup?.merchant_types || [{}]);
                setOutletTypes(businessSetup?.outlet_types || [{}]);
                setTaskTypes(businessSetup?.task_types || [{}]);
                setTopicOfIssues(businessSetup?.topic_of_issues || [{}]);
                setServiceTypes(businessSetup?.service_types || [{}]);
                setReturnReasons(businessSetup?.return_reasons || [{}]);
                setReplacementReasons(businessSetup?.replacement_reasons || [{}]);
                setAdjustmentReasons(businessSetup?.stock_adjustment_reasons || [{}]);
            } else if (currentSection === 'Commission') {
                setForfeitPeriod(settingListing?.data?.commission_forfeit_period)
            }
            else if (currentSection === 'Billing') {
                setQuotationValidity(settingListing?.data?.quotation_validity);
                setInvoicePaymentPeriod(settingListing?.data?.invoice_payment_period);
                setPaymentCollectionPeriod(settingListing?.data?.payment_collection_period);
            }
            else if (currentSection === 'Notification & Alert') {
                setOverduePaymentNotification(settingListing?.data?.overdue_payment_notification);
                setOverdueDeliveryNotification(settingListing?.data?.overdue_product_delivery_notification);
            }
            else if (currentSection === 'Loan Agreement') {
                setAgreementContent(settingListing?.data?.[0]?.template || '');
            }
            setIsLoading(false);
        }
    }, [settingListing])

    useEffect(() => {
        if (updateSetting?.code === "success") {
            setNotification({
                open: true,
                msg: "Settings updated successfully",
                type: "success",
            });
            dispatch(resetReuseableSettingActionState());
            initData();
        }
    }, [updateSetting])

    const settingList = [
        {
            iconName: 'ri-store-3-line',
            title: 'Business Setup',
        },
        {
            iconName: 'ri-coins-line',
            title: 'Commission',
        },
        {
            iconName: 'ri-receipt-line',
            title: 'Billing',
        },
        {
            iconName: 'ri-notification-line',
            title: 'Notification & Alert',
        },
        {
            iconName: 'ri-draft-line',
            title: 'Loan Agreement',
        },
    ]

    const businessSetupInputList = [
        {
            title: 'Merchant Types',
            description: 'Manage selectable business types used in merchant/outlet registration.',
            data: merchantTypes,
            section: 'merchant',
            setData: setMerchantTypes,
        },
        {
            title: 'Outlet Types',
            description: 'Manage selectable outlet types.',
            data: outletTypes,
            section: 'outlet',
            setData: setOutletTypes,
        },
        {
            title: 'Task Types',
            description: 'Manage selectable task types.',
            data: taskTypes,
            section: 'task',
            setData: setTaskTypes,
        },
        {
            title: 'Service Types',
            description: 'Manage selectable service types.',
            data: serviceTypes,
            section: 'service',
            setData: setServiceTypes,
        },
        {
            title: 'Topic of Issues',
            description: 'Manage selectable feedback\'s topic of issues.',
            data: topicOfIssues,
            section: 'topic',
            setData: setTopicOfIssues,
        },
        {
            title: 'Return Reason',
            description: 'Manage selectable return reasons.',
            data: returnReasons,
            section: 'return',
            setData: setReturnReasons,
        },
        {
            title: 'Replacement Reason',
            description: 'Manage selectable replacement reasons.',
            data: replacementReasons,
            section: 'replacement',
            setData: setReplacementReasons,
        },
        {
            title: 'Adjustment Reason',
            description: 'Manage selectable adjustment reasons.',
            data: adjustmentReasons,
            section: 'adjustment',
            setData: setAdjustmentReasons,
        },
    ]

    const initData = () => {
        setIsLoading(true);
        if (currentSection === 'Business Setup') {
            dispatch(getReuseableListing({ api: 'setting/business-setups' }));
        } else if (currentSection === 'Commission') {
            dispatch(getReuseableListing({ api: 'setting/operation?type=commission' }));
        } else if (currentSection === 'Billing') {
            dispatch(getReuseableListing({ api: 'setting/operation?type=billing' }));
        } else if (currentSection === 'Notification & Alert') {
            dispatch(getReuseableListing({ api: 'setting/operation?type=notification' }));
        } else if (currentSection === 'Loan Agreement') {
            dispatch(getReuseableListing({ api: 'setting/agreement-template' }));
        }
    }

    const businessSetupDataOnchange = (type, value, index) => {
        let newTypes = type === 'merchant' ? [...merchantTypes]
            : type === 'outlet' ? [...outletTypes]
                : type === 'task' ? [...taskTypes]
                    : type === 'service' ? [...serviceTypes]
                        : type === 'return' ? [...returnReasons]
                            : type === 'replacement' ? [...replacementReasons]
                                : type === 'adjustment' ? [...adjustmentReasons]
                                    : [...topicOfIssues];
        newTypes[index].name = value;
        if (type === 'merchant') {
            setMerchantTypes(newTypes);
        } else if (type === 'outlet') {
            setOutletTypes(newTypes);
        } else if (type === 'task') {
            setTaskTypes(newTypes);
        } else if (type === 'service') {
            setServiceTypes(newTypes);
        } else if (type === 'return') {
            setReturnReasons(newTypes);
        } else if (type === 'replacement') {
            setReplacementReasons(newTypes);
        } else if (type === 'adjustment') {
            setAdjustmentReasons(newTypes);
        } else {
            setTopicOfIssues(newTypes);
        }
    }

    const handleDeleteType = (type, index, hasId) => {
        let newTypes = type === 'merchant' ? [...merchantTypes]
            : type === 'outlet' ? [...outletTypes]
                : type === 'task' ? [...taskTypes]
                    : type === 'service' ? [...serviceTypes]
                        : type === 'return' ? [...returnReasons]
                            : type === 'replacement' ? [...replacementReasons]
                                : type === 'adjustment' ? [...adjustmentReasons]
                                    : [...topicOfIssues];
        newTypes[index].deleted = true;
        // newTypes.splice(index, 1);
        if (type === 'merchant') {
            setMerchantTypes(newTypes);
        } else if (type === 'outlet') {
            setOutletTypes(newTypes);
        } else if (type === 'task') {
            setTaskTypes(newTypes);
        } else if (type === 'service') {
            setServiceTypes(newTypes);
        } else if (type === 'return') {
            setReturnReasons(newTypes);
        } else if (type === 'replacement') {
            setReplacementReasons(newTypes);
        } else if (type === 'adjustment') {
            setAdjustmentReasons(newTypes);
        } else {
            setTopicOfIssues(newTypes);
        }

    }

    const handleBusinessSetupSubmit = () => {
        const filterMerchantTypes = merchantTypes.filter((item) => !item?.deleted && item?.name);
        const deletedMerchantTypes = merchantTypes.filter((item) => item?.deleted === true && item?.id) || [];

        const filterOutletTypes = outletTypes.filter((item) => !item?.deleted && item?.name);
        const deletedOutletTypes = outletTypes.filter((item) => item?.deleted === true && item?.id) || [];

        const filterTaskTypes = taskTypes.filter((item) => !item?.deleted && item?.name);
        const deletedTaskTypes = taskTypes.filter((item) => item?.deleted === true && item?.id) || [];

        const filterServiceTypes = serviceTypes.filter((item) => !item?.deleted && item?.name);
        const deletedServiceTypes = serviceTypes.filter((item) => item?.deleted === true && item?.id) || [];

        const filterTopicOfIssues = topicOfIssues.filter((item) => !item?.deleted && item?.name);
        const deletedTopicOfIssues = topicOfIssues.filter((item) => item?.deleted === true && item?.id) || [];

        const filterReturnReasons = returnReasons.filter((item) => !item?.deleted && item?.name);
        const deletedReturnReasons = returnReasons.filter((item) => item?.deleted === true && item?.id) || [];

        const filterReplacementReasons = replacementReasons.filter((item) => !item?.deleted && item?.name);
        const deletedReplacementReasons = replacementReasons.filter((item) => item?.deleted === true && item?.id) || [];

        const filterAdjustmentReasons = adjustmentReasons.filter((item) => !item?.deleted && item?.name);
        const deletedAdjustmentReasons = adjustmentReasons.filter((item) => item?.deleted === true && item?.id) || [];

        let payload = {
            merchant_types: filterMerchantTypes.map((item) => ({ name: item?.name, id: item?.id })),
            outlet_types: filterOutletTypes.map((item) => ({ name: item?.name, id: item?.id })),
            task_types: filterTaskTypes.map((item) => ({ name: item?.name, id: item?.id })),
            service_types: filterServiceTypes.map((item) => ({ name: item?.name, id: item?.id })),
            topic_of_issues: filterTopicOfIssues.map((item) => ({ name: item?.name, id: item?.id })),
            return_reasons: filterReturnReasons.map((item) => ({ name: item?.name, id: item?.id })),
            replacement_reasons: filterReplacementReasons.map((item) => ({ name: item?.name, id: item?.id })),
            stock_adjustment_reasons: filterAdjustmentReasons.map((item) => ({ name: item?.name, id: item?.id })),
        }
        if (deletedMerchantTypes.length > 0) {
            payload.deleted_merchant_types = deletedMerchantTypes.map((item) => (item?.id));
        }
        if (deletedOutletTypes.length > 0) {
            payload.deleted_outlet_types = deletedOutletTypes.map((item) => (item?.id));
        }
        if (deletedTaskTypes.length > 0) {
            payload.deleted_task_types = deletedTaskTypes.map((item) => (item?.id));
        }
        if (deletedServiceTypes.length > 0) {
            payload.deleted_service_types = deletedServiceTypes.map((item) => (item?.id));
        }
        if (deletedTopicOfIssues.length > 0) {
            payload.deleted_topic_of_issues = deletedTopicOfIssues.map((item) => (item?.id));
        }
        if (deletedReturnReasons.length > 0) {
            payload.deleted_return_reasons = deletedReturnReasons.map((item) => (item?.id));
        }
        if (deletedReplacementReasons.length > 0) {
            payload.deleted_replacement_reasons = deletedReplacementReasons.map((item) => (item?.id));
        }
        if (deletedAdjustmentReasons.length > 0) {
            payload.deleted_stock_adjustment_reasons = deletedAdjustmentReasons.map((item) => (item?.id));
        }
        if (deletedTopicOfIssues.length > 0) {
            payload.deleted_topic_of_issues = deletedTopicOfIssues.map((item) => (item?.id));
        }
        dispatch(updateReuseable({ api: 'setting/business-setups', reuseable: payload, id: '' }));
    }

    const handleCommissionUpdateSubmit = () => {
        let payload = {
            commission_forfeit_period: forfeitPeriod || 0
        }
        dispatch(updateReuseable({ api: 'setting/commission', reuseable: payload }));
    }

    const handleBillingUpdateSubmit = () => {
        let payload = {
            quotation_validity: quotationValidity || 0,
            invoice_payment_period: invoicePaymentPeriod || 0,
            payment_collection_period: paymentCollectionPeriod || 0
        }
        dispatch(updateReuseable({ api: 'setting/billing', reuseable: payload }));
    }

    const handleNotificationUpdateSubmit = () => {
        let payload = {
            overdue_payment_notification: overduePaymentNotification || 0,
            overdue_product_delivery_notification: overdueDeliveryNotification || 0
        }
        dispatch(updateReuseable({ api: 'setting/notification', reuseable: payload }));
    }

    const handleAgreementUpdateSubmit = () => {
        let payload = {
            template: agreementContent || ''
        }
        dispatch(updateReuseable({ api: 'setting/agreement-template', reuseable: payload }));
    }

    const handleSubmit = () => {
        setIsLoading(true);
        if (currentSection === 'Business Setup') {
            handleBusinessSetupSubmit();
        } else if (currentSection === 'Commission') {
            handleCommissionUpdateSubmit();
        } else if (currentSection === 'Billing') {
            handleBillingUpdateSubmit();
        } else if (currentSection === 'Notification & Alert') {
            handleNotificationUpdateSubmit();
        } else if (currentSection === 'Loan Agreement') {
            handleAgreementUpdateSubmit();
        }

    }

    const renderHeader = () => {
        return (
            <div className="p-1 pb-4">
                <div className="text-bold font-size-20">General Settings</div>
                <div className="subheader-2">Configure global parameters to streamline business operations and automate processes.</div>
            </div>
        )
    }


    const renderBusinessSetup = (setting) => {
        const filterBusinessTypes = setting?.data.filter((item) => !item?.deleted);

        return (
            <div className="mb-4">
                <div className="mb-2">
                    <div className="text-semibold">{setting?.title}</div>
                    <div className="subheader-2">{setting?.description}</div>
                </div>
                <Grid container spacing={2}>
                    <Grid item className="">
                        {
                            filterBusinessTypes.map((type, index) => (
                                <div className="d-flex align-items-center">
                                    <CustomTextField
                                        values={type?.name}
                                        onChange={(e) => businessSetupDataOnchange(setting.section, e, index)}
                                        disabled={!editable}
                                    />
                                    {
                                        deletable &&
                                        <ButtonBase style={{ marginLeft: 10, padding: 5, paddingInline: 10, borderRadius: 7 }} onClick={() => handleDeleteType(setting.section, index, Boolean(type?.id))}>
                                            <Icon icon="ri-delete-bin-6-line" color='#F65151' width={20} height={20} />
                                        </ButtonBase>
                                    }
                                </div>
                            ))
                        }
                    </Grid>
                </Grid>
                {
                    creatable &&
                    <div className="clickable" style={{ color: '#C0A45D', width: 'fit-content' }} onClick={() => setting.setData([...setting?.data, { name: '' }])}>
                        <div><i className="ri-add-line" /> Add Type</div>
                    </div>
                }
            </div>
        )
    }

    const renderCommision = () => {
        return (
            <div>
                <div className="mb-2">
                    <div className="text-semibold">Commission Forfeit Period</div>
                    <div className="subheader-2">Set the days the unclaimed commission will be forfeited after invoice due date.</div>
                </div>
                <Grid container spacing={2}>
                    <Grid item className="">
                        <CustomTextField
                            values={forfeitPeriod}
                            onChange={(e) => setForfeitPeriod(e)}
                            type={'number'}
                            placeholder={'0'}
                            InputProps={{ endAdornment: <div style={{ marginRight: 10 }}>days</div> }}
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }

    const renderBilling = () => {
        return (
            <div>
                <div className="mb-2">
                    <div className="text-semibold">Quotation Validity</div>
                    <div className="subheader-2">Set the number of days a quotation remain valid before expirying.</div>
                </div>
                <Grid container spacing={2}>
                    <Grid item className="">
                        <CustomTextField
                            values={quotationValidity}
                            onChange={(e) => setQuotationValidity(e)}
                            type={'number'}
                            placeholder={'0'}
                            InputProps={{ endAdornment: <div style={{ marginRight: 10 }}>days</div> }}
                        />
                    </Grid>
                </Grid>
                <div className="mt-4 mb-2">
                    <div className="text-semibold">Invoice Payment Period</div>
                    <div className="subheader-2">Set the days from the invoice date within which payment is expected.</div>
                </div>
                <Grid container spacing={2}>
                    <Grid item className="">
                        <CustomTextField
                            values={invoicePaymentPeriod}
                            onChange={(e) => setInvoicePaymentPeriod(e)}
                            type={'number'}
                            placeholder={'0'}
                            InputProps={{ endAdornment: <div style={{ marginRight: 10 }}>days</div> }}
                        />
                    </Grid>
                </Grid>
                <div className="mt-4 mb-2">
                    <div className="text-semibold">Payment Collection Period</div>
                    <div className="subheader-2">Set the days the salesperson has to collect payments after invoicing.</div>
                </div>
                <Grid container spacing={2}>
                    <Grid item className="">
                        <CustomTextField
                            values={paymentCollectionPeriod}
                            onChange={(e) => setPaymentCollectionPeriod(e)}
                            type={'number'}
                            placeholder={'0'}
                            InputProps={{ endAdornment: <div style={{ marginRight: 10 }}>days</div> }}
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }

    const renderNotiAndAlert = () => {
        return (
            <div>
                <div className="mb-2">
                    <div className="text-semibold">Overdue Payment Notifications</div>
                    <div className="subheader-2">Set the days after expected payment completion date that a notification will be triggered if payment is still pending.</div>
                </div>
                <Grid container spacing={2}>
                    <Grid item className="">
                        <CustomTextField
                            values={overduePaymentNotification}
                            onChange={(e) => setOverduePaymentNotification(e)}
                            type={'number'}
                            placeholder={'0'}
                            InputProps={{ endAdornment: <div style={{ marginRight: 10 }}>days</div> }}
                        />
                    </Grid>
                </Grid>
                <div className="mt-4 mb-2">
                    <div className="text-semibold">Overdue Product Delivery Notifications</div>
                    <div className="subheader-2">Set the days after expected delivery date that a notification will be triggered if delivery status is still pending or incomplete.</div>
                </div>
                <Grid container spacing={2}>
                    <Grid item className="">
                        <CustomTextField
                            values={overdueDeliveryNotification}
                            onChange={(e) => setOverdueDeliveryNotification(e)}
                            type={'number'}
                            InputProps={{ endAdornment: <div style={{ marginRight: 10 }}>days</div> }}
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }

    const renderLoanAgreement = () => {
        return (
            <div>
                <FormEditors
                    title={'Loan Agreement Terms & Condition'}
                    value={agreementContent || ''}
                    setValue={(e) => setAgreementContent(e)}
                />
            </div>
        )
    }

    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <Stack direction={"row"} justifyContent={"space-between"} gap={2}>
                        <CustomButton
                            title={'Cancel'}
                            press={() => navigate(-1)}
                            height={32}
                            backgroundColor={'white'}
                            textColor={'#000'}
                            borderStyle={"1px solid #EAE8E7"}
                            width={"50%"}
                        />
                        <CustomButton
                            title={"Save Changes"}
                            height={32}
                            press={() => handleSubmit()}
                            width={"50%"}
                        />
                    </Stack>
                </div>

            }
            <div className="page-content">
                <LoadingDialog open={loading} />
                <Header
                    breadcrumb={<Breadcrumbs
                        breadcrumbItems={[{ title: 'Settings', link: "/settings" }, { title: 'General Settings', link: "#" }]} />
                    }
                >
                    {
                        width > 728 &&
                        <Stack gap={1} direction={{ xs: "column", sm: "row" }} className="d-flex">
                            <CustomButton
                                title={'Cancel'}
                                press={() => navigate(-1)}
                                height={32}
                                backgroundColor={'white'}
                                textColor={'#000'}
                                borderStyle={"1px solid #EAE8E7"}
                            />
                            <CustomButton
                                title={"Save Changes"}
                                height={32}
                                press={() => handleSubmit()}
                            />
                        </Stack>
                    }
                </Header>
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    <Grid container spacing={2}>
                        <Grid item lg={2.5} md={3.5} sm={12} sx={{ display: { lg: 'block', md: 'block', sm: 'flex', xs: 'flex' }, overflowX: 'auto', width: { sm: '100%' } }}>
                            {
                                settingList.map((item, index) => (
                                    <ButtonBase key={index} className="d-flex align-items-center mb-2" style={{ backgroundColor: currentSection === item.title ? '#F8F8F8' : 'transparent', padding: 7, paddingInline: 10, borderRadius: 7, width: '100%' }} onClick={() => setCurrentSection(item.title)}>
                                        <Grid container spacing={1} alignItems="center" ml={0} paddingInline={"0px"} display={"flex"} style={{ minWidth: 200 }}>
                                            <Grid item md={2} sm={2}>
                                                <Icon icon={item.iconName} width={24} height={24} color="#7D7D7D" />
                                            </Grid>
                                            <Grid item md={10} sm={10} className="d-flex justify-content-start">
                                                <div>{item.title}</div>
                                            </Grid>
                                        </Grid>
                                    </ButtonBase>
                                ))
                            }
                        </Grid>
                        <Grid item lg={9.5} md={8.5}>
                            {
                                currentSection === 'Business Setup' && businessSetupInputList.map((setting, index) => (
                                    renderBusinessSetup(setting)
                                ))
                            }
                            {currentSection === 'Commission' && renderCommision()}
                            {currentSection === 'Billing' && renderBilling()}
                            {currentSection === 'Notification & Alert' && renderNotiAndAlert()}
                            {currentSection === 'Loan Agreement' && renderLoanAgreement()}
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ ReuseableReducer, Login }) {
    return {
        userPermission: Login.permissionArry,
        settingListing: ReuseableReducer.reuseableList,
        updateSetting: ReuseableReducer.editReuseableSetting,
    };
}

export default connect(mapStateToProps)(GeneralSetting);